import { ChecklistItem } from '@gsm/entities';
import { DynamicFormControlLayout, DynamicFormValueControlModel, DynamicFormValueControlModelConfig, serializable } from '@ng-dynamic-forms/core';

export const TYPE_CHECKLISTE = 'CHECKLISTE';

export interface ChecklisteModelConfig extends DynamicFormValueControlModelConfig<ChecklistItem[]> {
  additional: {
    checklistItemStatus: Record<string, string>;
  };
}

export class ChecklisteModel extends DynamicFormValueControlModel<ChecklistItem[]> {
  @serializable() readonly type: string = TYPE_CHECKLISTE;
  additional: {
    checklistItemStatus: Record<string, string>;
  };

  constructor(config: ChecklisteModelConfig, layout?: DynamicFormControlLayout) {
    super(config, layout);
  }
}
